import React from "react";

import styled from "styled-components/macro";

import { Chip } from "components/Chip";

const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

interface BusinessLabelChipsProps {
  names: string[];
}

export function BusinessLabelChips({ names }: BusinessLabelChipsProps) {
  if (!names.length) {
    return <span>-</span>;
  }
  return (
    <ChipList>
      {names.map(name => (
        <Chip key={name}>{name}</Chip>
      ))}
    </ChipList>
  );
}
